import React from 'react';
import {I18n, Translate} from 'react-redux-i18n';
import {useSelector, useDispatch} from 'react-redux';

import {Icon, stringUtils} from 'front-onceforall-core';

import {useLocation} from 'react-router-dom';

import {recordGAEvent} from '../../utils/analytics';
import {getBdrUrl} from '../../utils/path';
import {toggleModal} from '../../actions/modals';
import {toggleDiscoverBdrBox} from '../../actions/display';

import utils from './utils';
import {pathResolver} from '../../utils/basePathHelper';

function gaEventHideBox(location) {
  const path = location.pathname;
  recordGAEvent('BdR', `Hide discover Bdr box on ${path}`);
}

function gaEventAccess(location) {
  const path = location.pathname;
  recordGAEvent('BdR', `Accessed Bdr from ${path}`);
}

function openErrorModal(dispatch) {
  recordGAEvent('BdR', 'Opened Bdr error modal from BdR box');
  dispatch(toggleModal('accessBdrErrorModal', true));
}

function getTextPath(depositor, pathname) {
  if (depositor) {
    return 'bdr.discover.depositor.text';
  }
  if (pathname === '/dashboard') {
    return 'bdr.discover.collector.dashboard.text';
  }
  return 'bdr.discover.collector.other.text';
}

function DiscoverBdrBox() {
  const dispatch = useDispatch();
  const [organisation = {}, bdrServiceAuthorized, isBoxShown, userExistsInArtio] = useSelector(state => {
    const {organisationId} = state.organisation;
    const bdr = state.subscriptions?.[organisationId]?.bdrServiceAuthorized;
    const {showDiscoverBdrBox = true} = state.display?.[organisationId] || {};
    const existsInArtio = state?.user?.userExistsInArtio;
    return [state.organisation, bdr, showDiscoverBdrBox, existsInArtio];
  });
  const location = useLocation();

  const url = React.useMemo(() => getBdrUrl(organisation.organisationId), [organisation.organisationId]);

  if (
    !isBoxShown ||
    !utils.shouldDisplay(bdrServiceAuthorized, organisation, location.pathname)
  ) {
    return null;
  }

  const displayConfirmButton = () => {
    let onClick = () => {};
    let content = <Translate value="bdr.discover.confirm"/>;

    if (!userExistsInArtio) {
      onClick = () => openErrorModal(dispatch);
    } else {
      onClick = undefined;
      content = (
        <a
          target="_blank"
          rel="noopener noreferrer"
          href={url}
          onClick={() => gaEventAccess(location)}
        >
          {content}
        </a>
      );
    }

    return (
      <button
        type="button"
        className="large secondary inline-container"
        onClick={onClick}
      >
        {content}
      </button>
    );
  };

  const displayButtons = () => (
    <div className="d-flex flex-row justify-content-end mt-2">
      {displayConfirmButton()}
      <button
        className='ml-3'
        type="button"
        onClick={() => {
          dispatch(toggleDiscoverBdrBox(organisation.organisationId));
          gaEventHideBox(location);
        }}
      >
        <Icon
          tooltip={I18n.t('vitrine.discover.cancel')}
          icon="rounded-cross"
          size={25}
        />
      </button>
    </div>
  );

  const displayIcon = () => (
    <div
      className="d-flex flex-row justify-content-center align-items-center"
      style={{backgroundColor: '#3B2D6D', minWidth: '120px'}}
    >
      <img
        alt="logo bdr"
        src={pathResolver('resources/img/icon_bdr.png')}
        style={{maxWidth: '70px'}}
      />
    </div>
  );

  const displayTextBlock = () => (
    <div className='p-3 d-flex flex-column justify-content-center'>
      {stringUtils.getStrongs(I18n.t('bdr.discover.title'))}
      {I18n.t(getTextPath(organisation?.depositor, location.pathname))}
      {displayButtons()}
    </div>
  );

  return (
    <div className='mx-0 my-5 row d-flex justify-content-center'>
      <div className='w-50 d-flex flex-row justify-content-center'>
        {displayIcon()}
        <div className="background-white">
          {displayTextBlock()}
        </div>
      </div>
    </div>
  );
}

export default DiscoverBdrBox;
